export const DOCUMENT_TYPE = {
    0: 'Заявление участника команды',
    1: 'Письменное согласие Заявителя по экспертизе на предоставление Соискателем проекта для целей присвоения статуса Участника проекта',
    2: 'Заявление соискателя о намерении стать участником проекта, подписанное руководителем постоянно действующего исполнительного органа соискателя',
    3: 'Согласие на обработку персональных данных',
    4: 'Согласие на обработку персональных данных',
    5: 'Заверение о соответствии соискателя требованиям, предусмотренным пунктами 2, 7, 10 статьи 5 Положения присвоении и утрате статуса участника проекта «Сколково»'
};

export const DOCUMENT_STATUS = {
    20: 'Сформируйте документ',
    21: 'Необходимо подписать документ',
    22: 'Документ отправлен в Госключ',
    23: 'Документ подписан',
    24: 'Приложен скан с подписью',
    25: 'Отклонение подписания членом команды',
    1: 'Пользователь не найден',
    4: 'Истекло время подписания',
    11: 'Внутренняя ошибка системы',
    12: 'У пользователя нет сертификата УКЭП',
    13: 'Подпись не прошла проверку',
    14: 'Не удалось проверить подпись отправителя запроса'
};

export const SIGNATURE_TYPE = [
    {
        label: 'Приложить подписанный файл',
        value: '1',
    }, 
    {
        label: 'Отправить в Госключ',
        value: '2',
    }, 
    {
        label: 'Подписать в браузере',
        value: '3',
    }
];

export const availableFormats = [
    {
        signType: "1",
        formats: ["SIG", "P7S"]
    },
    {
        signType: "0",
        formats: ["PDF", "JPG", "JPEG"]
    }
];

export const langOptions = [
    {
        label: "ru",
        name: "Русский"
    },
    {
        label: "en",
        name: "Английский"
    }
];
